import {doc, onSnapshot } from 'firebase/firestore';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { db } from '../firebase';

const NoticePeople = () => {
  const location = useLocation();
  const [noticePeople,setNoticePeople] = useState([]);

  useEffect(()=>{
    onSnapshot(doc(db, "noticeAll", location.state.noticePeopleId), (doc) => {
      let array=[]
      array.push({id:doc.id,...doc.data()})
      setNoticePeople(array);
  });
  },[])
  return (
    <React.Fragment>
         <header className="text-[#ffffff] bg-blue-900 body-font">
        <div className="relative lg:py-5 bg-[#ffffff] ">
          <div className="grid grid-cols-7 text-center  ">
          <div className=" lg:ml-10  invisible sm:visible md:visible lg:visible">
              <img
                src="./assets/sail.png"
                alt="pic"
                className="h-32 w-32 "
              />
            </div>
            <div className="flex flex-wrap flex-col col-span-5  ">
              <h1 className="lg:text-5xl text-2xl text-black font-semibold text-center mt-1 ">
                Bokaro Ispat Senior Secondary School-8B
              </h1>
              <h1 className=" lg:text-2xl text-md text-center  mt-1 font-semibold  text-black ">
                 NEAR SURYA MANDIR BOKARO STEEL CITY,
              </h1>
              <h1 className="text-center font-semibold text-black lg:text-xl text-sm">
                BOKARO JHARKHAND-827009
              </h1> 
            </div>
            <div className="lg:ml-10 invisible sm:visible md:visible lg:visible">
              <img
                src="./assets/as_logo.png"
                alt="pic"
                className="h-32 w-32 "
              />
            </div>
          </div>
        </div>

    
       {/* Nav  Start */}
       <nav className="flex-col flex-grow h-10 md:pb-0 hidden md:flex  md:flex-row  md:justify-center items-center">
          <ul className="flex">
          <Link to={"/home"}>
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 duration-150  hover:scale-125 mb-1 md:mb-0">
                <span className="font-semibold">Home</span>
            </li>
            </Link>
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:scale-125 mb-1 md:mb-0 z-10 ">
            
                <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">About Us</span>
              
              <ul className="absolute left-0 top-1 mt-8 shadow-lg bg-blue-900 z-10 hidden group-hover:block box-border h-32 w-32 p-2 ">
              <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300">
                 <Link to={"/aboutUs"}>
                   <span className="flex text-base border-b-2 border-slate-500">
                     About BISSS
                   </span>
                   </Link>
               </li>
                <Link to={"/schoolManagementCommittee"}>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                    <span className="flex  text-base">School Management Committee</span>
                </li>
                </Link>
              </ul>
            </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:scale-125 mb-1 md:mb-0">
            
                <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">Academics</span>
              
              <ul className="absolute left-0 top-1 mt-8  rounded-lg shadow-lg bg-blue-900 z-10  hidden group-hover:block box-content h-45 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  
                    <span className="flex text-base border-b-2 border-slate-500">
                      TC Issued
                    </span>
                  
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  
                    <span className="flex text-base border-b-2 border-slate-500">
                      Student Vacency
                    </span>
                  
                </li>

                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  
                    <span className="flex text-base ">
                      Admission Category Wise Enrollement Position
                    </span>
                  
                </li>
              </ul>
            </li> */}
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:scale-125 duration-150 mb-1 z-10 md:mb-0">
                <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">Admission</span>
              
              <ul className="absolute left-0 top-1 mt-8  shadow-lg bg-blue-900 z-10  hidden group-hover:block box-content h-45 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/feestructure"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Fee Structure
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/acadenicsession"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Academics Session
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:scale-125 mb-1 md:mb-0 duration-150">
                <span className="font-semibold">Activities</span>
            </li>
            <li className="relative mx-1 px-1 py-2 group mr-6  text-white-600 hover:scale-125 duration-150  mb-1 md:mb-0 z-10">
                <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">Facilities</span>
              
              <ul className="absolute left-0 top-1 mt-8 shadow-lg bg-blue-900 z-10  hidden group-hover:block box-content h-45 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/indoorgames"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Indoor Games
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/musicrooms"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Music Rooms
                    </span>
                  </Link>
                </li>

                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/dancerooms"}>
                    <span className="flex text-base border-b-2 border-slate-500 ">
                      Dance Rooms
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/library"}>
                    <span className="flex text-base  ">Library</span>
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125  mb-1 md:mb-0">
                <span className="font-semibold">Work</span>
                </li> */}
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125 duration-150 mb-1 md:mb-0">
                <span className="font-semibold">Gallery</span>
                </li> */}
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125  mb-1 md:mb-0">
                <span className="font-semibold">Online Fee</span>
                </li> */}
                   <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125 duration-150  mb-1 md:mb-0">
                    <Link to="../uploadSyllabus">
                <span className="font-semibold">Syllabus</span>
                </Link>
                </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125 duration-150 mb-1 md:mb-0">
                <span className="font-semibold">Contact Us</span>
                </li> */}
            <li className="relative mx-1 px-1 py-2 group mr-6 hover:scale-125 duration-150  mb-1 md:mb-0">
                 <Link to={"/login"}>
                <span className="font-semibold">Login</span>
                </Link>
                </li>
          </ul>
        </nav>
       {/* Nav  End */}
      </header>
     
     <div className='min-h-screen lg:pl-60 lg:pr-60 pl-2 pr-2  pt-5'>
     {noticePeople.map((item,index)=>(
   <div className='w-full border'key={index}>
   <div className="text-center" >
   <div className="grid lg:grid-cols-3 bg-[#033f63] w-full py-2 text-center font-bold text-white text-xl">
   <div className='hidden'>{++index}</div>
  <div className='col-span-2'>{item.noticeTitle}</div>
  <div className='invisible lg:visible'>{item.noticeDate.split('-').reverse().join('-')}</div>
 </div>
    <div className=" w-64 mx-auto py-2 underline underline-offset-8">
    <span className='text-center font-bold text-black  mt-5 text-xl '>NOTICE</span>
  </div>
 </div>
 <div className='mt-8 ml-8 mr-8 text-left'>{item.notice}</div> 
 <div className='mt-8 mb-8 text-left ml-8'>
      <div className='mt-2'>Regards,</div>
      <div className='mt-2 uppercase'>s s yadav</div>
      <div className='mt-2 uppercase'>Principal</div>
   </div>
 </div>
))}
     </div>


    <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
</React.Fragment>
  )
}

export default NoticePeople